import { render, staticRenderFns } from "./online_shop_component.vue?vue&type=template&id=43ffbdf4&scoped=true&"
import script from "./online_shop_component.vue?vue&type=script&lang=js&"
export * from "./online_shop_component.vue?vue&type=script&lang=js&"
import style0 from "./online_shop_component.vue?vue&type=style&index=0&id=43ffbdf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ffbdf4",
  null
  
)

export default component.exports